import React from 'react';
import './ProgramNewPage.css';
import Container from '../components/Container';
import '../styles/generics.css'
import logo from '../images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import CompanyPage from './CompanyPage';
import MaskedInput from '../components/MaskedInput';
import AdminPage from './AdminPage';
import AppStorage from '../config/AppStorage';


const creationType = [
  "CNPJ"
];


export default class PasswordPage extends PageComponent {
  static PageInfo = {

    path: "/ResetPassword",
    name: "menu.password",
    hidden: true,
    icon: "key"
  }

  loaded = { brands: null, types: null, payment: null, billing: null, period: null, qatype: null };

  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    this.key = urlParams.get("key");
    this.data = props.match.params;
    this.state.data = null;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.modalError = null;
    this.state.isModalVisible = null;
    this.state.password2 = null;
    this.state.form = {
      brand: null,
      hierarchy: null,
      fkClientType: null,
      label: null,
    };
    this.state.promotionalBudgetTypeId = null;
  }
  componentDidMount() {
    if (typeof this.key !== "string" || this.key.length == 0)
      window.location.replace("/");
  }

  changePassword() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + "Login/Password",
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          token: decodeURIComponent(this.key),
          password: this.state.password,
          email: this.state.email
        })
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          AppStorage.ClearUserCredentials();
          this.setState({ isModalVisible: null, modalLoading: false }, () =>
            window.location.replace("/")
          );
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  render() {
    return (
      <div className="generics_panels" style={{ display: "block", textAlign: "center", padding: 40 }}>
        {
          <div>
            <img className="login_panel_logo_image" src={logo} alt="LONGPING HIGH-TECH" />
            <div style={{ margin: 20, textAlign: "left", border: "1px solid rgb(240,240,240)", padding: 20 }}>
              <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
              <div>
                <div style={{ padding: 20 }}>
                  <div style={{ padding: 20, backgroundColor: "#f4f4f4", fontSize: 20, border: "1px solid rgb(200,200,200)", marginBottom: 20 }}>
                    {Labels.GetLabel("password.body")}
                  </div>
                  <div className="generic_section_header">{Labels.GetLabel('clientsnew.newpassword')}</div>
                  <form autoComplete="off">
                    <MaskedInput type="email" autoComplete={false} notnull={true} label={Labels.GetLabel("generic.email")} onValid={(value) => this.setState({ email: value })}
                      onInvalid={(value) => this.setState({ email: null })} />
                    <MaskedInput type="text" autoComplete={false} notnull={true} label={Labels.GetLabel("generic.password")} onValid={(value) => {
                      var v = value;
                      if (value.length < 8 || !/[^A-Za-z 0-9]/g.test(value) || !/[A-Z]/g.test(value) || !/[0-9]/g.test(value)) v = null;


                      this.setState({ password: v, password2: null });

                      if (v != null) return true;
                      else return false;
                    }}
                      onInvalid={(value) => this.setState({ password: null })} password={true} />
                    <div style={{ border: "1px solid #c15c5c", padding: 20, backgroundColor: "#fff3f3" }}>{Labels.GetLabel("password.warning")}</div>
                    <br />
                    <MaskedInput type="text" autoComplete={false}
                      notnull={true} label={Labels.GetLabel("password.confirm")} onValid={(value) => {
                        this.setState({ password2: value });
                        if (this.state.password == value) return true;
                        return false;
                      }}
                      onInvalid={(value) => this.setState({ password2: null })} password={true} />
                  </form>
                  <br />
                  <br />
                  <div style={{ textAlign: "right", marginTop: 30 }}>
                    <Button variant="success" size="lg" disabled={this.state.email == null || this.state.password == null || this.state.password2 == null} onClick={() => this.setState({ isModalVisible: "confirm", modalLoading: false })}>{Labels.GetLabel("generic.confirm")}</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible != null}

        >
          <div>
            {
              this.state.modalInitializing == true ?
                <div>
                  {Labels.GetLabel("adminstategroup.saving")}
                </div>
                :
                this.state.isModalVisible == "error" ?
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel(this.constructor.PageInfo.name)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {Labels.GetLabel("clientsnew.confirmation")}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                        {Labels.GetLabel("adminstategroup.closebtn")}
                      </Button>
                      {/* <Button variant="primary" onClick={() => this.addNew()}>
                        {Labels.GetLabel("adminstategroup.savebtn")}
                      </Button> */}
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div>
                  :
                  this.state.isModalVisible == "success" ?
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel(this.constructor.PageInfo.name)}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {Labels.GetLabel("clientsnew.confirmation")}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                          {Labels.GetLabel("adminstategroup.closebtn")}
                        </Button>
                        {/* <Button variant="primary" onClick={() => this.addNew()}>
                          {Labels.GetLabel("adminstategroup.savebtn")}
                        </Button> */}
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
                    :
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel(this.constructor.PageInfo.name)}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {Labels.GetLabel("clientsnew.confirmation")}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                          {Labels.GetLabel("adminstategroup.closebtn")}
                        </Button>
                        <Button variant="primary" onClick={() => this.changePassword()}>
                          {Labels.GetLabel("generic.confirm")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
            }
          </div>
        </Modal>
      </div>
    );
  }
} 